// src/utils/onlineStatus.js
export function isOnlineMode() {
  return localStorage.getItem("mode") === "online";
}

export function setOnlineMode(online) {
  localStorage.setItem("mode", online ? "online" : "offline");
}
